// extracted by mini-css-extract-plugin
var _1 = "EntityPhaseList-moduleEntityPhaseList__JbnjJ";
var _2 = "EntityPhaseList-modulescrollable__Z13Bj";
export { _1 as "EntityPhaseList", _2 as "scrollable" }
